import React, { useState } from 'react';
import { FastField, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Label, Card, CardBody, Container } from 'reactstrap';
import ReCAPTCHA from 'react-google-recaptcha';
import { limparDocumento, validaDocumento } from '../../utils/documentoAlfanumerico';
import { abrirBoletos } from '../../utils/boletos/abrir-boletos';
import { getVisaoSacadoTitulos } from '../../api/relatorios';
import { postObterBoletoAreaSacado } from '../../api/boletos';
import { CPFInput, If, getConfigAmbiente, SkeletonLoader } from '../../shared';
import Grid from '../commom/Grid';
import titulosGrid from './SegundaViaGrid';
import { moneyFullFormat, transformTableTitulosData } from '../../utils/format';
import imageDefault from '../../assets/img/botao-fechar.svg';
import './styles.scss';

export default () => {
  const [isPending, setPending] = useState(false);
  const [message, setMessage] = useState(false);
  const [relatorios, setRelatorios] = useState({});
  const [itensCount, setItensCount] = useState(0);
  const [jwtLote, setJwtLote] = useState(false);
  const [isBtnFiltrarDisabled, setBtnFiltrarDisabled] = useState(true);
  const [mensagemMarketing, setMensagemMarketing] = useState(null);

  const [checkedAll, setCheckedAll] = useState({ checked: false, disabled: false });
  const recaptchaRef = React.createRef();

  const configAmbiente = getConfigAmbiente();
  const siteInstitucional =
    configAmbiente && configAmbiente.sistema && configAmbiente.sistema.site_institucional
      ? configAmbiente.sistema.site_institucional
      : process.env.REACT_APP_SITELANDINGPAGE;

  const logo =
    configAmbiente &&
    configAmbiente.imagens &&
    configAmbiente.imagens.LOGO &&
    configAmbiente.imagens.LOGO !== 'image-default'
      ? configAmbiente.imagens.LOGO
      : imageDefault;

  const handleSubmit = (values, actions) => {
    const recaptchaValue = recaptchaRef.current.getValue();
    recaptchaRef.current.reset();
    setPending(true);
    setRelatorios({});
    setMessage();
    values = {
      ...values,
      recaptchaValue: recaptchaValue,
      cpfCnpjCedente: limparDocumento(values.cpfCnpjCedente),
      cnpj: limparDocumento(values.cnpj)
    };

    return getRelatoriosHandler(values).finally(() => {
      actions.setSubmitting(false);
      setBtnFiltrarDisabled(true);
    });
  };

  const getRelatoriosHandler = values => {
    return getVisaoSacadoTitulos(values)
      .then(res => {
        let { data } = res;
        setMensagemMarketing(data.marketing);
        const dataTitulos = data.titulos;
        setJwtLote(data.jwt_lote);

        let valorTotal =
          dataTitulos.length &&
          dataTitulos.map(item => item.valorDevido).reduce((acc, curr) => acc + curr);
        let valorDevido =
          dataTitulos.length &&
          dataTitulos.map(item => item.valorTitulo).reduce((acc, curr) => acc + curr);

        dataTitulos.forEach(item => {
          let disabled = true;
          if (item.boleto) {
            disabled = false;
          }

          item.meta = {
            visible: true,
            disabled: disabled,
            checked: false
          };
        });

        let newRelatorios = {
          dataTitulos,
          valorTotal,
          valorDevido
        };
        setRelatorios(newRelatorios);

        setCheckedAll({ checked: false, disabled: false });

        if (dataTitulos.length === 0) {
          setMessage('Nenhum resultado foi encontrado com estes filtros');
        }
      })
      .catch(() => {
        setMessage('Por favor, preencha o captcha e tente novamente.');
      })
      .finally(() => {
        setPending(false);
        setItensCount(0);
      });
  };

  const handleCheck = event => {
    const { checked, value } = event.target;
    const newRelatorios = [...relatorios.dataTitulos];
    let intensCount = 0;
    let marcaCheckAll = newRelatorios.length > 0 ? true : false;
    let desmarcaCheckAll = false;

    newRelatorios.forEach(item => {
      if (parseInt(item.id) === parseInt(value)) {
        item.meta.checked = checked;
      }

      if (item.meta.checked) {
        intensCount++;
      } else if (item.boleto) {
        desmarcaCheckAll = true;
        marcaCheckAll = false;
      }
    });

    const valorTotal =
      newRelatorios.length &&
      newRelatorios.map(item => item.valorDevido).reduce((acc, curr) => acc + curr);
    const valorDevido =
      newRelatorios.length &&
      newRelatorios.map(item => item.valorTitulo).reduce((acc, curr) => acc + curr);

    newRelatorios.dataTitulos = newRelatorios;
    newRelatorios.valorTotal = valorTotal;
    newRelatorios.valorDevido = valorDevido;

    setItensCount(intensCount);
    setRelatorios(newRelatorios);

    if (marcaCheckAll === true) {
      setCheckedAll({ checked: true, disabled: false });
    } else if (desmarcaCheckAll === true) {
      setCheckedAll({ checked: false, disabled: false });
    }
  };

  const handleCheckAll = event => {
    let { checked } = event.target;
    let newRelatorios = [...relatorios.dataTitulos];

    let intensCount = 0;
    newRelatorios.forEach(item => {
      if (item.boleto) {
        item.meta.checked = checked;
      }
      if (item.meta.checked) {
        intensCount++;
      }
    });

    let valorTotal =
      newRelatorios.length &&
      newRelatorios.map(item => item.valorDevido).reduce((acc, curr) => acc + curr);
    let valorDevido =
      newRelatorios.length &&
      newRelatorios.map(item => item.valorTitulo).reduce((acc, curr) => acc + curr);

    newRelatorios.dataTitulos = newRelatorios;
    newRelatorios.valorTotal = valorTotal;
    newRelatorios.valorDevido = valorDevido;

    setItensCount(intensCount);
    setRelatorios(newRelatorios);
    setCheckedAll({ checked: checked, disabled: false });
  };

  const handlerSelectAction = event => {
    const { value } = event.target;
    const atualizado = value && value === 'atualizado';
    event.preventDefault();

    const newRelatorios = [...relatorios.dataTitulos];

    let titulos = [];
    newRelatorios.forEach(item => {
      if (item.meta.checked && item.boleto) {
        titulos.push(item.boleto.jwt_boleto);
      }
    });

    if (titulos && titulos.length > 0 && jwtLote) {
      const payload = { lote: titulos };
      if (atualizado) payload.atualizado = true;
      abrirBoletosTitulos(payload, jwtLote);
    } else {
      alert('Sem boletos para geraçao');
    }
  };

  const verificacaoReCaptcha = value => {
    if (value) {
      setBtnFiltrarDisabled(false);
    } else {
      setBtnFiltrarDisabled(true);
    }
  };

  const mensagemButton = () => {
    return isBtnFiltrarDisabled ? 'Preencha o captcha para pesquisar' : '';
  };

  const CPFInputWrapper = props => <CPFInput {...props} />;

  const verificaMobille = () => {
    let mobille = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
      ? 'SITE'
      : 'ACESSAR SITE';
    return mobille;
  };

  const dados = relatorios.dataTitulos || [];

  const todosValidos =
    dados.length > 0 &&
    dados.every(
      rel => rel.stto !== 'RD' && !['CM', 'SC', 'ES'].includes(rel.ttoop) && rel.redesconto !== 'S'
    );

  const obterBoletoTituloIndividual = boleto => {
    if (!boleto || !boleto.jwt_boleto) return false;
    const payload = boleto.atualizado && boleto.tipo === 'atualizado' ? { atualizado: true } : {};
    abrirBoletosTitulos(payload, boleto.jwt_boleto);
  };

  const abrirBoletosTitulos = (payload, jwt) => {
    payload.tipo_retorno = 'html';
    abrirBoletos({
      payload,
      endPointObterBoleto: postObterBoletoAreaSacado,
      setPending,
      setMessage,
      configEndPoint: {
        headers: {
          Authorization: `Bearer ${decodeURIComponent(jwt)}`
        }
      }
    });
  };

  return (
    <Container className="authentication d-flex justify-content-center heightAuto">
      <Card className="segundaVia animated fadeIn">
        <CardBody>
          <div className="row alignItensCenter">
            <div className="col-lg-5 marginLeft-15">
              <div
                className="img-logo"
                style={{
                  backgroundImage: `url(${logo})`,
                  marginLeft: '15px'
                }}
                alt="Logo empresa"
              />
            </div>
            <div className="col-lg-5">
              <div className="font30"> 2ª Via Boleto</div>
            </div>
            <div className="col-lg-2">
              <a
                className="visaoSacadoBtn btnVsCuston"
                disabled={isPending}
                href={siteInstitucional}
                target="_blank"
                rel="noopener noreferrer"
              >
                {verificaMobille()}
              </a>
            </div>
          </div>
          <hr />
          <Formik
            initialValues={{
              cpfCnpjCedente: '',
              cnpj: ''
            }}
            validationSchema={Yup.object().shape({
              cpfCnpjCedente: Yup.string()
                .nullable()
                .required('Campo Obrigatório.')
                .test({
                  exclusive: true,
                  message: params => {
                    const strippedValue = limparDocumento(params.value);
                    if (strippedValue.length === 11) {
                      return 'CPF inválido.';
                    } else if (strippedValue.length === 14) {
                      return 'CNPJ inválido.';
                    }
                    return 'CPF/CNPJ inválido.';
                  },
                  name: 'CPF-CNPJ',
                  test: value => {
                    if (!value) return true;
                    const documento = limparDocumento(value);
                    return validaDocumento(value) || documento.length === 14;
                  }
                }),
              cnpj: Yup.string()
                .nullable()
                .required('Campo Obrigatório.')
                .test({
                  exclusive: true,
                  message: params => {
                    const strippedValue = limparDocumento(params.value);
                    if (strippedValue.length === 11) {
                      return 'CPF inválido.';
                    } else if (strippedValue.length === 14) {
                      return 'CNPJ inválido.';
                    }
                    return 'CPF/CNPJ inválido.';
                  },
                  name: 'CPF-CNPJ',
                  test: value => {
                    if (!value) return true;
                    const documento = limparDocumento(value);
                    return validaDocumento(value) || documento.length === 14;
                  }
                }),
              reCaptcha: Yup.string().test({
                exclusive: true,
                message: () => {
                  return 'Prencha o Captcha.';
                },
                name: 'reCaptcha',
                test: () => {
                  let recaptchaValue = recaptchaRef.current.getValue();
                  if (recaptchaValue) {
                    return true;
                  }
                  return false;
                }
              })
            })}
            onSubmit={handleSubmit}
            render={({ isSubmitting }) => {
              return (
                <div className="row">
                  <Form className="col-lg-3">
                    <FastField
                      type="text"
                      label="CEDENTE"
                      labelClassName="required-label"
                      name="cpfCnpjCedente"
                      id="cpfCnpjCedente"
                      uppercase
                      disabled={isSubmitting}
                      autoComplete="nope"
                      component={CPFInputWrapper}
                      placeholder="INFORME UM CNPJ"
                    />

                    <FastField
                      type="text"
                      label="SACADO"
                      labelClassName="required-label"
                      name="cnpj"
                      id="cnpj"
                      uppercase
                      disabled={isSubmitting}
                      autoComplete="nope"
                      component={CPFInputWrapper}
                      placeholder="INFORME UM CPF OU CNPJ"
                    />

                    <ReCAPTCHA
                      name="reCaptcha"
                      ref={recaptchaRef}
                      sitekey="6LegwOMUAAAAAGRAeW77vEWbLEWKX6-YcJovqkj0" //<- CHAVE PUBLICA DO RECAPTCHA
                      onChange={verificacaoReCaptcha}
                      className="responsividadeCaptcha"
                    />

                    {message && message !== 'Nenhum resultado foi encontrado com estes filtros' && (
                      <div className="alert alert-danger animated fadeIn" role="alert">
                        {message}
                      </div>
                    )}

                    <div className="button-group">
                      <Button
                        type="submit"
                        color="primary"
                        className="ml-auto"
                        title={mensagemButton()}
                        disabled={isPending || isSubmitting || isBtnFiltrarDisabled}
                      >
                        <i className="fa fa-search" />
                        Pesquisar
                      </Button>
                    </div>
                  </Form>

                  {todosValidos && (
                    <div className="shape">
                      <p>
                        {mensagemMarketing.DESCRICAO_MARKETING_VISAO_CLIENTE}
                        {mensagemMarketing.LINK_MARKETING_VISAO_CLIENTE && (
                          <a
                            href={`https://${mensagemMarketing.LINK_MARKETING_VISAO_CLIENTE}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {mensagemMarketing.LINK_MARKETING_VISAO_CLIENTE}
                          </a>
                        )}
                      </p>
                    </div>
                  )}

                  <SkeletonLoader
                    isPending={isPending}
                    width="100%"
                    height="60px"
                    count={8}
                    widthRandomness={0}
                  >
                    <If test={Object.keys(relatorios).length > 0}>
                      <div className="col-md-12 d-flex flex-row-reverse bd-highlight marginBotton10">
                        <div
                          className={`form-inline selecao-itens animated ${
                            itensCount ? 'fadeIn' : 'fadeOut esconder'
                          }`}
                        >
                          <span className="selecao-itens-numero m-2 half-rounded-circle">
                            {itensCount}
                          </span>
                          {itensCount > 1 ? 'Boletos em Lote' : 'Boleto em Lote'}
                          <select
                            className="form-control ml-2"
                            disabled={itensCount === 0}
                            onChange={handlerSelectAction}
                            value="nenhuma"
                          >
                            <option value="nenhuma">Imprimir</option>
                            <option value="original">Original</option>
                            <option value="atualizado">Atualizado</option>
                          </select>
                        </div>
                      </div>

                      <Grid
                        keyField="id"
                        tableSearch={true}
                        data={transformTableTitulosData(relatorios.dataTitulos)}
                        configuracaoColunas={titulosGrid(
                          handleCheck,
                          checkedAll,
                          handleCheckAll,
                          obterBoletoTituloIndividual
                        )}
                        mensagem={message}
                        classes="table-layout-fixed"
                        classeIdentificadora="visaoSacadoTitulos"
                      />

                      {relatorios.dataTitulos && Object.keys(relatorios.dataTitulos).length > 0 && (
                        <div className="col-lg-12" style={{ marginTop: 5 }}>
                          <div className="col-md-12 ml-auto mt-12 text-right">
                            <Label className="col-md-12 col-lg-6 col-xl-3 align-items-center">
                              Quantidade
                              <span className="badge badge-visaoSacado">
                                {relatorios.dataTitulos.length}
                              </span>
                            </Label>
                            <Label className="col-md-12 col-lg-6 col-xl-3 align-items-center">
                              Valor Total
                              <span className="badge badge-visaoSacado">
                                {moneyFullFormat(relatorios && relatorios.valorDevido)}
                              </span>
                            </Label>
                          </div>
                        </div>
                      )}
                    </If>
                  </SkeletonLoader>
                </div>
              );
            }}
          />
        </CardBody>
      </Card>
    </Container>
  );
};
